import React from 'react';
import { RiDeleteBinLine } from 'react-icons/ri';
import './index.css';
import Spinner from '../../../../components/Spinner';

const TransactionStep = ({
  reportData,
  newTransaction,
  setNewTransaction,
  handleAddTransaction,
  handleDeleteTransaction,
  isTransactionLoading,
  nextStep
}) => {
  const saldoInicial = reportData.saldoInicialCaja || 0;
  const totalIngresos = reportData.transactions.debit;
  const totalEgresos = reportData.transactions.credit;
  const saldoSegunOperaciones = saldoInicial + totalIngresos - totalEgresos;
  const balanceOperacionesIngreso = saldoInicial + totalIngresos;
  const balanceOperacionesEgreso = totalEgresos + saldoSegunOperaciones;

  return (
    <div className="mainPanel">
      <div className="panelHeader">
        <h3>INFORME DIARIO DE CAJA</h3>
        <div className="dateDisplay">
          {new Date().toLocaleDateString('es-ES', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
        </div>
      </div>

      <div className="transactionGrid">
        <div className="detailColumn">
          <div className="transactionTable">
         
             {newTransaction.showInput ? (
              <div className="inputOverlay d-flex" style={{ gap: 12, alignItems: 'center' }}>
                <input
                  type="text"
                  placeholder="Introduzca el detalle"
                  className="minimalInput"
                  value={newTransaction.description}
                  onChange={e =>
                    setNewTransaction({ ...newTransaction, description: e.target.value })
                  }
                />
                <div className="inputGroup d-flex" style={{ gap: 8, alignItems: 'center' }}>
                  <input
                    type="number"
                    placeholder="Monto"
                    className="minimalInput amountInput"
                    value={newTransaction.amount}
                    onChange={e =>
                      setNewTransaction({ ...newTransaction, amount: e.target.value })
                    }
                  />
                  <select
                    className="minimalSelect"
                    value={newTransaction.type}
                    onChange={e =>
                      setNewTransaction({ ...newTransaction, type: e.target.value })
                    }
                  >
                    <option value="debit">DÉBITO</option>
                    <option value="credit">CRÉDITO</option>
                  </select>
                </div>
                <div className="actionButtons d-flex" style={{ gap: 8 }}>
                  <button
                    className="btn btn-blue"
                    onClick={handleAddTransaction}
                    disabled={isTransactionLoading}
                  >
                    {isTransactionLoading ? <Spinner size={18} /> : 'AGREGAR'}
                  </button>
                  <button
                    className="btn btn-secondary"
                    onClick={() =>
                      setNewTransaction({ ...newTransaction, showInput: false })
                    }
                    disabled={isTransactionLoading}
                  >
                    CANCELAR
                  </button>
                </div>
              </div>
              ) : (
                <button
                  className="btn btn-blue addButton"
                  onClick={() =>
                    setNewTransaction({ ...newTransaction, showInput: true })
                  }
                >
                  + AGREGAR OTROS
                </button>
  
            )}
            <div className="transactionTable">
              <div className="tableHeaderRow">
                <div className="tableHeaderCell detailHeader">DETALLE</div>
                <div className="tableHeaderCell debitHeader">DÉBITO</div>
                <div className="tableHeaderCell creditHeader">CRÉDITO</div>
                {/* <div className="tableHeaderCell actionHeader">ACCIÓN</div> */}
              </div>
             
              <div className="tableBody">
                {reportData.transactions.details.length === 0 ? (
                  <div className="tableRow">
                    <div className="tableCell detailCell" colSpan={4} style={{ textAlign: 'center' }}>
                      No hay transacciones registradas
                    </div>
                  </div>
                ) : (
                  <>
                    {reportData.transactions.details.map((detail, index) => (
                      <div key={index} className="tableRow" style={{fontWeight: 'bold'}}>
                        <div className="tableCell detailCell">{detail.description}</div>
                        <div className="tableCell debitCell">
                          {detail.type === 'debit'
                            ? detail.amount.toFixed(2)
                            : ''}
                        </div>
                        <div className="tableCell creditCell">
                          {detail.type === 'credit'
                            ? detail.amount.toFixed(2)
                            : ''}
                        </div>
                        {/* <div className="tableCell actionCell">
                          {!detail.fromAPI && (
                            <button
                              className="deleteButton"
                              onClick={() => handleDeleteTransaction(index)}
                              disabled={isTransactionLoading}
                            >
                              <RiDeleteBinLine size={16} />
                            </button>
                          )}
                        </div> */}
                      </div>
                    ))}
                    {isTransactionLoading && (
                      <div className="tableRow">
                        <div className="tableCell detailCell" colSpan={4} style={{ textAlign: 'center' }}>
                          <Spinner size={24} type={2} />
                          
                        </div>
                      </div>
                    )}
                  </>
                )}
              
                {/* Totales y balances */}
                <div className="tableRow tableTotals" style={{ backgroundColor: '#0F4372' }}>
                  <div className="tableCell detailCell"><span style={{color: 'white'}}>TOTAL INGRESOS/EGRESOS</span></div>
                  <div className="tableCell debitCell debitTotal">
                    <span>{totalIngresos.toFixed(2)}</span>
                  </div>
                  <div className="tableCell creditCell creditTotal">
                    <span>{totalEgresos.toFixed(2)}</span>
                  </div>
                  {/* <div className="tableCell actionCell"></div> */}
                </div>
                <div className="tableRow tableTotals" >
                  <div className="tableCell detailCell"><b>SALDO INICIAL CAJA</b></div>
                  <div className="tableCell debitCell">
                    <span>{saldoInicial.toFixed(2)}</span>
                  </div>
                  <div className="tableCell creditCell"></div>
                  {/* <div className="tableCell actionCell"></div> */}
                </div>
                <div className="tableRow tableTotals">
                  <div className="tableCell detailCell"><b>SALDO SEGÚN OPERACIONES PARA SIGUIENTE MES</b></div>
                  <div className="tableCell debitCell"></div>
                  <div className="tableCell creditCell">
                    <span>{saldoSegunOperaciones.toFixed(2)}</span>
                  </div>
                  {/* <div className="tableCell actionCell"></div> */}
                </div>
                <div className="tableRow tableTotals">
                  <div className="tableCell detailCell"><b>BALANCE EN OPERACIONES</b></div>
                  <div className="tableCell debitCell">
                    <span>{balanceOperacionesIngreso.toFixed(2)}</span>
                  </div>
                  <div className="tableCell creditCell">
                    <span>{balanceOperacionesEgreso.toFixed(2)}</span>
                  </div>
                  {/* <div className="tableCell actionCell"></div> */}
                </div>
              </div>
             
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionStep;